<template lang="pug">
section#registration-confirmation.section.page-section.top-section
  spinner(v-if="settings.loading")
  div(v-else)
    .event-header(:style="`background-image:url(${backgroundUrl})`")
      .container
        h1.is-size-1 Thanks for signing up
        p.collection-desc.is-size-5.has-text-grey-light We&rsquo;ll see you at {{ event.title }} on {{ event.start_date | date('MMMM Do') }}. If you have any questions or aren&rsquo;t able to make it, please contact {{ contact.name }} at <a href="`mailto:${contact.email}`">{{ contact.email }}</a>.
        router-link.button.is-medium.is-primary(:to="{ name: 'home' }") Return to Home
</template>

<script>
import { mapGetters } from 'vuex';
import cloudinary from 'cloudinary-core';
import Spinner from '@/components/Spinner.vue';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'registration-confirmation',
  components: {
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      event: getterTypes.GET_EVENT,
    }),
    backgroundUrl() {
      if (!this.event._embedded.artwork) return null;
      let opts = {};
      if (this.isMobile) {
        opts = {
          width: 600,
          height: 600,
          effect: 'blur:700',
          quality: 'auto',
          fetch_format: 'auto',
          crop: 'thumb',
          opacity: 30,
          format: 'png',
        };
      } else {
        opts = {
          width: 2000,
          height: 700,
          effect: 'blur:700',
          quality: 'auto',
          fetch_format: 'auto',
          crop: 'fill',
          opacity: 30,
          format: 'png',
        };
      }
      return this.cloudinary.url(this.event._embedded.artwork.cl_id, opts);
    },
    contact() {
      const defaultContact = {
        name: 'the church office',
        email: this.account.email,
      };
      if (this.event.id === undefined || this.event._embedded.contact.id === undefined) return defaultContact;
      return this.event._embedded.contact;
    },
    isMobile() {
      return window.innerWidth <= 769;
    },
  },
  async created() {
    this.settings.loading = true;
    this.cloudinary = cloudinary.Cloudinary.new({
      cloud_name: process.env.VUE_APP_CLOUDINARY_CLOUD_NAME,
    });
    await this.$store.dispatch(actionTypes.DO_GET_EVENT, {
      id: this.id,
      zoom: 'artwork,contact',
    });
    this.settings.loading = false;
  },
  data() {
    return {
      cloudinary: null,
      settings: {
        loading: false,
      },
    };
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
#registration-confirmation {
  .event-header {
    @include hero;
    .button {
      margin-top: 2rem;
    }
  }
  .event-body {
  }

  @media (max-width: $tablet) {
    .event-header {
      background-size: cover;
      background-attachment: inherit;
    }
  }
  // background-color: #0a0a0a;
  // color: $white;
  // min-height: 100rem;
  // .image {
  //   max-width: 600px;
  //   display: block;
  //   margin: 0 auto;
  // }
  // h1 {
  //   margin: 1rem 0 0.75rem 0;
  //   font-size: 1.75rem;
  // }
  // p {
  //   color: $theme-grey;
  // }
  // .button {
  //   margin: 1.5rem 0;
  // }
  // @media (max-width: $tablet) {
  //   &.section {
  //     padding-top: 0 !important;
  //   }
  //   .image {
  //     max-width: 100%;
  //   }
  // }
}
</style>

<style lang="scss" theme="cwo">
#registration-confirmation {
  .event-header {
    a:not(.button) {
      &:hover {
        color: $primary;
        text-decoration: underline;
      }
    }
  }
}
</style>
